import { spawn, all } from 'redux-saga/effects';
import * as signUpSagas from './sagas/signUpSagas';
import * as locationSagas from './sagas/locationSagas';
import * as notificationCenterSagas from './sagas/notificationCenterSagas';
import * as currentUserSagas from './sagas/currentUserSagas';
import * as editProfileSagas from './sagas/editProfileSagas';
import * as subscriptionSagas from './sagas/subscriptionSagas';
import * as groupMembershipSagas from './sagas/groupMembershipSagas';
import * as additionalInformationSagas from './sagas/additionalInformationSagas';
import * as helpAndAnswerSagas from './sagas/helpAndAnswerSagas';

function* rootSaga() {
  yield all([
    spawn(signUpSagas.watchGetSubscriptions),
    spawn(signUpSagas.watchGetCurrentUserInit),
    spawn(signUpSagas.watchGetSettings),
    spawn(signUpSagas.watchCreateAccount),
    spawn(signUpSagas.watchCreateAccountForPublicOrg),
    spawn(signUpSagas.watchWithinGeoFence),
    spawn(signUpSagas.watchGetPrivateUserInfo),
    spawn(signUpSagas.watchGetAsIsState),
    spawn(signUpSagas.watchFetchCountries),
    spawn(signUpSagas.watchFetchPublicProfile),
    spawn(signUpSagas.watchFetchLanguageSettings),
    spawn(locationSagas.watchFetchStatesAndCountries),
    spawn(locationSagas.watchFetchGeocodingAddresses),
    spawn(locationSagas.watchSaveGeocodingAddress),
    spawn(notificationCenterSagas.watchGetNotificationList),
    spawn(notificationCenterSagas.watchGetNotification),
    spawn(notificationCenterSagas.watchGetWeatherAlertList),
    spawn(notificationCenterSagas.watchGetWeatherAlert),
    spawn(currentUserSagas.watchGetProfileInit),
    spawn(currentUserSagas.watchRecaptchaVerified),
    spawn(currentUserSagas.watchSendTestNotification),
    spawn(editProfileSagas.watchSaveMyProfile),
    spawn(locationSagas.watchGetLocationList),
    spawn(locationSagas.watchGetExpectedLocationList),
    spawn(locationSagas.watchDeleteLocation),
    spawn(locationSagas.watchDeleteExpLocation),
    spawn(locationSagas.watchSaveOrUpdateLocations),
    spawn(locationSagas.watchSaveOrUpdateExpLoc),
    spawn(subscriptionSagas.watchGetGroupSubscriptionList),
    spawn(subscriptionSagas.watchGetIncidentSubscriptionList),
    spawn(subscriptionSagas.watchUpdateGroupSubscriptionList),
    spawn(subscriptionSagas.watchUpdateAlertSubscriptionList),
    spawn(subscriptionSagas.watchUpdateIncidentSubscriptionList),
    spawn(subscriptionSagas.watchCheckShowIncidentSub),
    spawn(groupMembershipSagas.getGroupMembershipList),
    spawn(groupMembershipSagas.watchGroupMembershipList),
    spawn(additionalInformationSagas.watchCustomFields),
    spawn(additionalInformationSagas.watchSaveCustomFields),
    spawn(helpAndAnswerSagas.watchGetHelpAndAnswer),
  ]);
}

export default rootSaga;
